import { Container } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import CsrPlanHeader from '@/components/csr-plan/CsrPlanHeader';
import CsrPlanKanban from '@/components/csr-plan/CsrPlanKanban';

export const Route = createFileRoute('/_layout/$slug/csr-plan')({
  component: CsrPlan,
});

export default function CsrPlan() {
  const [editMode, setEditMode] = useState(false);

  return (
    <Container maxW="full" maxH="100vh" overflow={'hidden'} p={0}>
      <CsrPlanHeader editMode={editMode} setEditMode={setEditMode} />
      <CsrPlanKanban editMode={editMode} />
    </Container>
  );
}
